import PropTypes from 'prop-types'
import React, { useRef, useEffect, useContext, useState } from 'react'
import { ThemeContext } from 'styled-components'
import { Helmet } from 'react-helmet'

import HowItWorks from 'components/_special/HowItWorks'
import KitScience from 'components/_special/KitScience'
import ProductTextLineBanner from 'components/_special/ProductTextLineBanner'
import FaqBlock from 'components/FaqBlock'
import { RU } from 'constants/countries'
import { GOODS_TYPES } from 'constants/sales'
import { DEVELOPMENT } from 'constants/environments'
import { cityAdsWGSPage } from 'constants/cityAdsScripts'
import CartSaleWideContainer from 'containers/CartSaleWideContainer'
import { LayoutContext } from 'contexts/Layout'
import { LocalizationContext } from 'contexts/Localization'
import { ResizeContext } from 'contexts/Resize'
import { wgsHowItWorks, wgsResults } from 'routes'

import WillLearnDna from '../../components/WillLearnDna'

import WAboutCompareDetails from './components/WAboutCompareDetails'
import WAboutCompareFirst from './components/WAboutCompareFirst'
import WAboutFirstBlock from './components/WAboutFirstBlock'
import WAboutSpecializedReport from './components/WAboutSpecializedReport'
import WCovering from './components/WCovering'
import WForever from './components/WForever'
import {
  SectionsWrapperStyled,
  ForeverBox,
  CoveringBox,
  Wrapper,
} from './styles'
import HeaderPad from '../DnaAbout/components/HeaderPad'
import Intro from '../DnaAbout/components/Intro'

const WgsAbout = ({ texts, locale }) => {
  const secondBlock = useRef(null)
  const viewport = useContext(ResizeContext)
  const { paths } = useContext(LocalizationContext)
  const { setBodyColor, setFooterBg, setFooterColor } = useContext(
    LayoutContext,
  )
  const { colors } = useContext(ThemeContext)

  useEffect(() => {
    setFooterBg(colors.purpleHeart)
    setFooterColor(colors.whiteOp5)
    setBodyColor(colors.black)

    return () => {
      setFooterBg(null)
      setFooterColor(null)
      setBodyColor(null)
    }
  }, [setFooterBg, setBodyColor, colors, setFooterColor])

  const [IntroRenderSource, setIntroRenderSource] = useState('server')
  useEffect(() => {
    setIntroRenderSource('client')
  }, [])

  return (
    <>
      {(process.env.NODE_ENV !== DEVELOPMENT && locale === RU)
        && <Helmet><script id='xcntmyAsync' type='text/javascript'>{cityAdsWGSPage}</script></Helmet>
      }
      {locale === RU ? (
        <>
          <HeaderPad />
          <Intro
            key={`Intro-WGS-${IntroRenderSource}-render`}
            translations={{
              ...texts.first,
              title: texts.first.title || texts.first.title_consultation,
            }}
            goodsType={GOODS_TYPES.wgs}
          />
        </>
      ) : (
        <WAboutFirstBlock data={texts.first} secondBlockRef={secondBlock} />
      )}

      <ProductTextLineBanner />

      <div ref={secondBlock} className="pb-4">
        <WillLearnDna
          data={texts.traits}
          mobile={viewport.mobile}
          results={wgsResults}
          isNoWrapContent={false}
          isTextWhite={true}
          bgClassName={'bg--purple'}
        />
      </div>

      <Wrapper>
        <ForeverBox>
          <WForever data={texts.forever} />
        </ForeverBox>
        <CoveringBox>
          <WCovering data={texts.covering} {...{ viewport }} />
        </CoveringBox>
      </Wrapper>

      <WAboutCompareFirst
        header={texts.compare.header}
        text={texts.compare.text}
      />

      <WAboutCompareDetails data={texts.compare.list} />

      <WAboutSpecializedReport data={texts.specialized_report} />

      <HowItWorks
        data={texts.how_works}
        coverUrl={`${paths.cdn_global}/common_hiw/hiw/how_the_test_works`}
        link={wgsHowItWorks}
      />

      <KitScience
        data={texts.science}
        mobile={viewport.mobile}
        tablet={viewport.tablet}
        bgColor="purple"
        squareBg="transparent"
      />

      <div className="pt-2 pt-md-4">
        <FaqBlock
          isMobile={viewport.mobile}
          items={texts.faq.list}
          title={texts.faq.title}
          locale={locale}
          colorTheme="dark"
        />
      </div>

      <div className="pt-2 pt-md-4">
        <SectionsWrapperStyled isOverflowHidden={true}>
          <CartSaleWideContainer productType={GOODS_TYPES.wgs} />
        </SectionsWrapperStyled>
      </div>
    </>
  )
}

WgsAbout.propTypes = {
  language: PropTypes.string.isRequired,
  locale: PropTypes.string.isRequired,
  texts: PropTypes.object.isRequired,
}

export default WgsAbout
